// src/redux/slices/supervisors/supervisorsThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as supervisorService from "../../../services/supervisorService"; // Importe toutes les fonctions du service

/**
 * Thunk pour récupérer la liste de tous les superviseurs.
 */
export const fetchSupervisors = createAsyncThunk(
  "supervisors/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await supervisorService.fetchAllSupervisors();
      return response.data; // Le backend retourne directement le tableau
    } catch (error) {
      toast.error("Erreur lors du chargement des superviseurs.");
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

/**
 * Thunk pour créer un nouveau superviseur.
 */
export const createSupervisor = createAsyncThunk(
  "supervisors/create",
  async (supervisorData, { rejectWithValue }) => {
    try {
      const response = await supervisorService.createNewSupervisor(supervisorData);
      toast.success(`Le superviseur "${supervisorData.name}" a été créé avec succès !`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Erreur lors de la création du superviseur.";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

/**
 * Thunk pour assigner des délégués à un superviseur.
 */
export const assignDelegatesToSupervisor = createAsyncThunk(
  "supervisors/assignDelegates",
  async ({ supervisorId, delegateIds }, { rejectWithValue }) => {
    try {
      const response = await supervisorService.assignDelegates(supervisorId, delegateIds);
      toast.success("L'assignation des délégués a été mise à jour avec succès.");
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Erreur lors de l'assignation des délégués.";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);